import React from 'react';
import PropTypes from 'prop-types';

import TextBoxClient from 'client/components/TextBoxClient';
import { bgTypes } from 'styles/generateBgStyleByType';
import ResponsiveCoverImage from 'components/CoverPage/CoverFgImage';
import useCoverSettingComponentStyle from 'hooks/useCoverSettingComponentStyle';

export default function CoverPage({ onClick = () => {}, content }) {
    const coverSettingStyle = useCoverSettingComponentStyle();
    const isFgImageOnly = coverSettingStyle.foregroundTab === bgTypes.IMG;

    if (isFgImageOnly) {
        return (
            <ResponsiveCoverImage
                desktopImage={coverSettingStyle.foregroundDesktopImg}
                mobileImage={coverSettingStyle.foregroundMobileImg}
                onClick={onClick}
                isEditor={false}
            />
        );
    }

    return (
        <TextBoxClient
            style={{ backgroundColor: 'transparent', cursor: 'pointer' }}
            onClick={onClick}
            content={content}
            ignoreContentPadding
            shouldUseCompressedImg
        />
    );
}

CoverPage.propTypes = {
    onClick: PropTypes.func,
    content: PropTypes.string
};
